import styled, { css } from "styled-components";

import {
  DeleteButton,
  DeleteButtonWrapper,
  FixedWrapper,
} from "@FillInTableContainer/shared/styles/deleteButton.style";
import {
  DefaultDraggableGroupShellWrapper,
  GroupShellTitleWrapper,
  OutsideWrapper,
} from "@FillInTableContainer/shared/styles/groupShell.style";
import {
  SelectButton,
  SelectButtonDivider,
  SelectButtonDividerWrapper,
  SelectContentWrapper,
} from "@FillInTableContainer/shared/styles/rowSelectButton.style";

export const GroupShellOutsideWrapper = styled.div`
  position: relative;
  padding-left: 0;
`;

export const GroupShellWrapper = styled(OutsideWrapper)<{
  $isDisabled: boolean;
}>`
  display: flex;
  flex-direction: column;
  width: 100%;

  ${({ $isDisabled }) =>
    $isDisabled &&
    css`
      /* opacity: 0.3; */
      pointer-events: none;
      cursor: not-allowed;
    `}
`;

export const GroupShell = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  width: 100%;
`;

export const FixedDeleteButtonWrapper = styled(FixedWrapper)<{
  isShellTitle: boolean;
  isSeparatedTitleRow?: boolean;
  isSeparatedTitlePosition?: number;
}>`
  top: -2.4rem;
  left: -0.2rem;
  right: auto;

  ${({ isShellTitle }) =>
    isShellTitle &&
    css`
      top: -2.4rem;
      left: -0.2rem;
    `}
`;

export const DeleteTableButtonWrapper = styled(DeleteButtonWrapper)``;

export const DeleteTableButton = styled(DeleteButton)``;

export const SelectWrapper = styled(SelectContentWrapper)``;

export const GroupShellSelectButton = styled(SelectButton)``;

export const GroupShellSelectButtonDivider = styled(SelectButtonDivider)``;

export const GroupShellSelectButtonDividerWrapper = styled(
  SelectButtonDividerWrapper,
)<{ isFinancialTerms: boolean }>`
  ${({ isFinancialTerms }) =>
    isFinancialTerms &&
    css`
      display: none;
    `}
`;

export const TitleWrapper = styled(GroupShellTitleWrapper)``;
export const DraggableSubGroupShellWrapper = styled(
  DefaultDraggableGroupShellWrapper,
)``;
